import React from 'react'
import {SpinnerContainer,CircleOne,CircleTwo,CircleThree,CirclesContainer} from './style'
import config from "../../config/enviroment";

type TypeSpinner = {
    showPowered?: boolean,
    color?: string,
    size?: string
}

const Spinner = ({
  showPowered = false,
  color = "#1C0E49",
  size = "48px"
}:TypeSpinner) => {

 return (
  <SpinnerContainer>
    {showPowered ? (
       <img src={`${config.urlMultimedia}/babilonia/v4/iconos/loading-epayco-negro.gif`}/>
    ) : (
      <CirclesContainer>
        <CircleOne color={color} size={size}/>
        <CircleTwo color={color} size={size}/>
        <CircleThree color={color} size={size}/>
    </CirclesContainer>
    )}
  </SpinnerContainer>
 )
}

export default Spinner